module.exports = __webpack_public_path__ + "static/img/info_filled.6c234dbc.svg";